export const rubrosHistoricos = [
   {
        "anio" : "2026",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                 "trimestre" : "Primer Trimestre",
                 "url" : "../../Transparencia/historico/2026/UPLAPH_1erTrim2026.zip"
            }
        ]
    },
    {
        "anio" : "2025",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                 "trimestre" : "Primer Trimestre",
                 "url" : "../../Transparencia/historico/2025/UPLAPH_1erTrim2025.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "../../Transparencia/historico/2025/UPLAPH_2doTrim2025.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "../../Transparencia/historico/2025/UPLAPH_3erTrim2025.zip"
            },
             {
                 "trimestre" : "Cuarto Trimestre",
                 "url" : "../../Transparencia/historico/2025/UPLAPH_4toTrim2025.zip"
             }
        ]
    },
    {
        "anio" : "2024",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                 "trimestre" : "Primer Trimestre",
                 "url" : "../../Transparencia/historico/2024/UPLAPH_1erTrim2024.zip"
             },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "../../Transparencia/historico/2024/UPLAPH_2doTrim2024.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "../../Transparencia/historico/2024/UPLAPH_3erTrim2024.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "../../Transparencia/historico/2024/UPLAPH_4toTrim2024.zip"
            }
        ]
    },
    {
        "anio" : "2023",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "../../Transparencia/historico/2023/UPLAPH_1erTrim2023.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "../../Transparencia/historico/2023/UPLAPH_2doTrim2023.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "../../Transparencia/historico/2023/UPLAPH_3erTrim2023.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "../../Transparencia/historico/2023/UPLAPH_4toTrim2023.zip"
            }
        ]
    },
    {
        "anio" : "2022",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "../../Transparencia/historico/2022/UPLAPH_1erTrim2022.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "../../Transparencia/historico/2022/UPLAPH_2doTrim2022.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "../../Transparencia/historico/2022/UPLAPH_3erTrim2022.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "../../Transparencia/historico/2022/UPLAPH_4t0Trim2022.zip"
            }
        ]
    },
    {
        "anio" : "2015 - 2017",
        "descripcion" : "Ejercicios Anteriores",
        "trimestres" : [
            {
                "trimestre" : "Plataforma Nacional",
                "url" : "https://consultapublicamx.plataformadetransparencia.org.mx/vut-web/faces/view/consultaPublica.xhtml#inicio"
            }
        ]
    },
    {
        "anio" : "Información Histórica 21 Rubros",
        "descripcion" : "Ejercicios Anteriores",
        "trimestres" : [
            {
                "trimestre" : "Descargar",
                "url" : "../../Transparencia/historico/historico.zip"
            }
        ]
    }
]